/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useMemo, useContext } from "react";

import { bem } from "../../../shared/BEM";
import { renderFormElementList } from "./renderFormElement";
import { useFormElement } from "../../../shared/hooks/useFormElement";
import { FormRowList } from "../../../shared/FormModel/elements/FormRowList";
import { Button } from "../Common/ButtonComponent";
import { ConfigContext } from "../../ConfigContext";

/**
 * Component props
 */
export interface IFormRowListComponentProps {
	element: FormRowList
}

export function FormRowListComponent(props: IFormRowListComponentProps) {

	const configCtx = useContext(ConfigContext);
	const state = useFormElement(props.element);

	const handleAdd = useMemo(() => () => {

		props.element.add();

	}, [ props.element ]);

	const stl = bem("form-row-list");

	return <div className={stl.str}>
		<div className={stl.el("container").str}>
			{state.items.map((item) => <div key={item.id} className={stl.el("item").str}>
				{renderFormElementList(item.content)}
				{configCtx.mode === "browser" ?
					<div className={stl.el("item-actions").str}>
						<button title="Posunout nahoru" onClick={() => props.element.moveUp(item.id)}><i className="mdi mdi-menu-up" /></button>
						<button title="Odebrat" className="larger" onClick={() => props.element.remove(item.id)}><i className="mdi mdi-delete" /></button>
						<button title="Posunout dolů" onClick={() => props.element.moveDown(item.id)}><i className="mdi mdi-menu-down" /></button>
					</div>
				: null}
			</div>)}
		</div>

		{configCtx.mode === "browser" ?
			<div className={stl.el("add").str}>
				<Button label="Přidat řádek" icon="plus" size="default" style="default" onClick={handleAdd} />
			</div>
		: null}
	</div>;

}